import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

interface FilterButton {
  value: string;
  labelKey: string;
  icon: string;
}

@Component({
  selector: 'app-status-filter',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './status-filter.html',
  styleUrls: ['./status-filter.css']
})
export class StatusFilterComponent {
  @Input() statusFilter = '';
  @Input() statusCounts: Record<string, number> = {};
  @Output() statusChange = new EventEmitter<string>();

  filterButtons: FilterButton[] = [
    { value: '', labelKey: 'statusFilter.all', icon: 'list' },
    { value: 'PENDING', labelKey: 'statusFilter.newApplication', icon: 'schedule' },
    { value: 'APPROVED', labelKey: 'statusFilter.approved', icon: 'check_circle' },
    { value: 'REJECTED', labelKey: 'statusFilter.rejected', icon: 'cancel' },
    { value: 'UNDER_CONSIDERATION', labelKey: 'statusFilter.underConsideration', icon: 'pending' },
    { value: 'ALLOCATED', labelKey: 'statusFilter.allocated', icon: 'assignment_turned_in' }
  ];

  setStatusFilter(status: string): void {
    this.statusChange.emit(status);
  }

  getStatusCount(status: string): number {
    return this.statusCounts[status] || 0;
  }
}
